import React from 'react';
import PropTypes from 'prop-types';
import { Form, Field } from 'redux-form';
import { checkButtonDisabled } from '../../utils/forms';
import InputField from '../shared/InputField';

export default class ForgotPasswordForm extends React.Component {
  static propTypes = {
    invalid: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    sendForgotPasswordEmailFunction: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.sendForgotPasswordEmail = this.sendForgotPasswordEmail.bind(this);
  }

  sendForgotPasswordEmail = evt => {
    const { sendForgotPasswordEmailFunction } = this.props;
    sendForgotPasswordEmailFunction(evt);
  };

  render() {
    const { invalid, handleSubmit, submitting } = this.props;

    return (
      <Form id="forgotPasswordForm" onSubmit={handleSubmit(this.sendForgotPasswordEmail)}>
        <fieldset>
          <Field
            name="userEmail"
            component={InputField}
            type="text"
            placeholder="example@exampledomain.com"
            label="Email"
            autoFocus
          />
        </fieldset>
        <button
          type="submit"
          className="btn btn-primary"
          disabled={checkButtonDisabled(invalid, submitting)}
        >
          Send Email
        </button>
      </Form>
    );
  }
}
